import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import useMsalApi from '../../components/use-msal-api';
import { StructuredListSkeleton, StructuredListWrapper, StructuredListHead, Button, StructuredListRow, StructuredListCell } from "carbon-components-react";
import { displayStatus, formatDate } from '../../components/formatters';
import EventLog from '../submission/event-log';
import { set } from 'date-fns';

const ApprovedSubmissions = () => {
    const [submissions, setSubmissions] = useState();
    const [callApi] = useMsalApi();
    const [showLog, setShowLog] = useState(false);
    const [enrollmentId, setenrollmentId] = useState();


    useEffect(() => {
        if(!showLog){
            getSubmissions();           
        }
    }, [showLog])

    const getSubmissions = async () => {
        const results = await callApi("Enrollments/ApprovedInProgress", "GET");
        if(!results.error)
            setSubmissions(results);
    }

    const runSubmission = async (e, id) => {
        e.target.disabled = true;
        setenrollmentId(id);
        const results = await callApi(`Enrollments/Run/${id}`, "GET");
        if(!results.error)
            setShowLog(true);
        
        e.target.disabled = false;
    }

    return ( 
        <>
           <h3>Approved In Progress Submissions</h3>
            {submissions ? 
                <StructuredListWrapper>
                    <StructuredListHead>
                        <StructuredListRow head>
                            <StructuredListCell head>Employee</StructuredListCell>
                            <StructuredListCell head>Effective Date</StructuredListCell>
                            <StructuredListCell head>Next Step</StructuredListCell>
                            <StructuredListCell head>Next Attempt</StructuredListCell>
                            <StructuredListCell head></StructuredListCell>
                        </StructuredListRow>                    
                    </StructuredListHead>
            
                {submissions.map((submission, idx) =>
                    <StructuredListRow  key={idx}>
                        <StructuredListCell>{submission.employeeName} <br />
                        <span className='text-gray-400'>{submission.employeeNumber}</span>
                        </StructuredListCell>
                        <StructuredListCell>{formatDate(submission.effectiveDate)}</StructuredListCell>
                        <StructuredListCell>{displayStatus(submission.statusId)}</StructuredListCell>
                        <StructuredListCell>Today at 9:30pm</StructuredListCell>
                        <StructuredListCell>
                            <Button size="sm" kind="tertiary" onClick={(e) => runSubmission(e,submission.id)}>Run now</Button>
                        </StructuredListCell>
                    </StructuredListRow>                
                )}
                </StructuredListWrapper>
                : 
                <StructuredListSkeleton />

            }
            <EventLog show={showLog} setShow={setShowLog} enrollmentId={enrollmentId} />

        </>
     );
}
 
export default ApprovedSubmissions;